import axios from "axios";
const CONTROLLER_PATH = "DayBatch";
class ClaimService {
    //CREATE
    create(claim) {
        return axios.post(CONTROLLER_PATH, claim).then((response) => response.data);
    }
    generateCoverPage(dayBatchId) {
        return axios.post(CONTROLLER_PATH + "/GenerateCoverPage", null, { params: { id: dayBatchId } }).then((response) => response.data);
    }

    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }
    getpostsubmissionreducedview(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + "/GetReducedView" + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }
    getDayBatchPostSubmissionFormDto(id, requestId) {
        return axios.get(CONTROLLER_PATH + "/GetDayBatchPostSubmissionFormDto/" + id, { params: {}, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }
    //UPDATE
    update(id, formData) {
        return axios
            .put(CONTROLLER_PATH + "/" + id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }

    setCoverPrintedVerified(id, isPrintedVerified) {
        return axios.post(CONTROLLER_PATH + "/SetCoverPrintedVerified", null, { params: { id, isPrintedVerified } }).then((response) => response.data);
    }

    setisprocessed(id, isProcessed) {
        return axios.post(CONTROLLER_PATH + "/SetIsProcessed", null, { params: { id, isProcessed } }).then((response) => response.data);
    }
    
    setreturnedcoverdocument(id, formData) {
        return axios
            .put(CONTROLLER_PATH + "/SetReturnedCoverDocument/" + id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {});
    }
}

export default new ClaimService();
